import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getTheme,
  getIsMobile,
  getPromos,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  hasFirstTimeFlag,
  FirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { getEnabledFlagsList } from '@wix/da-shared-react/pkg/redux/flags/selectors';
import { AppState } from '../../../types/store';
import { appLoaded, pathChange } from '../../actions/app';
import {
  isSectionLoading,
  getActiveSection,
  getActiveSectionAppUrl,
} from '../../selectors/sections';
import { getCoverDeviation } from '../../selectors/deviations';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
  isViewingAsVisitor,
} from '../../selectors/users';
import { getIsRepositioningProfileHero } from '../../selectors/profileHeroEditor';

import App, { Props } from './App';

type StateProps = Pick<
  Props,
  | 'activeSection'
  | 'environment'
  | 'profileOwner'
  | 'theme'
  | 'isMobile'
  | 'isOwner'
  | 'isSectionLoading'
  | 'isViewingAsVisitor'
  | 'showProfileEditAid'
  | 'showProfileHeroAid'
  | 'appUrl'
  | 'flags'
>;
type DispatchProps = Pick<Props, 'onAppRendered' | 'onPathChange'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const coverDeviation = getCoverDeviation(state);
  const profileOwnerUser = getProfileOwnerUser(state);
  const isOwner = isCurrentUserProfileOwner(state);
  const isHeroEditingActive = getIsRepositioningProfileHero(state);
  const promos = getPromos(state);
  return {
    activeSection: getActiveSection(state),
    isMobile: getIsMobile(state),
    isOwner,
    profileOwner: profileOwnerUser,
    isSectionLoading: isSectionLoading(state),
    isViewingAsVisitor: isViewingAsVisitor(state),
    theme: getTheme(state),
    environment: state.environment.type,
    showProfileHeroAid:
      isOwner &&
      !coverDeviation &&
      hasFirstTimeFlag(state, FirstTimeFlag.ProfileHeroAidNotClosed) &&
      !isHeroEditingActive,
    showProfileEditAid:
      isOwner &&
      hasFirstTimeFlag(state, FirstTimeFlag.ProfileEditAidNotClosed) &&
      !isHeroEditingActive,
    isHeroEditingActive,
    appUrl: getActiveSectionAppUrl(state),
    flags: getEnabledFlagsList(state),
    promos,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onAppRendered: appLoaded,
  onPathChange: pathChange,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
